import styled from 'styled-components';

export const Button = styled.button`
  outline: none;
  color: #141204;
  background: transparent;
  border-radius: 12px;
  border: 2px solid #FFCD00;
  padding: 9px 34px 8px;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  cursor: pointer;
  transition: all .15s;
  font-family: 'Lato', Arial, sans-serif;
  &:hover {
    box-shadow: none;
    background-color: #FFCD00;
  }
  &:active {
    transform: scale(0.97);
  }
  &:disabled {
    background-color: #C4C4C4;
    color: #fff;
    border-color: #C4C4C4;
  }

  @media (max-width: 1024px){
    font-size: 18px;
    line-height: 22px;
  }
  @media (max-width: 768px){
    background-color: #FFCD00;
    padding: 9px 28px 8px;
    &:active {
      /*background-color: #F0B538;
      border-color: #F0B538;*/
    }
  }
  @media (max-width: 425px){
    border-radius: 8px;
    font-size: 16px;
    line-height: 19px;
    padding: 11px 32px 10px;
  }
`;

export const ButtonReverse = styled(Button)`
  background-color: #FFCD00;
`

export const ButtonTiny = styled.button`
  outline: none;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  line-height: 0;
  transition: all .3s;
  &:hover {
    box-shadow: none;
  }
`;

export const ButtonFilter = styled(Button)`
  font-size: 16px;
  line-height: 19px;
  padding: 14px 28px 13px;
  border: 2px solid ${props => props.active ? '#FFCD00' : '#E0E0E0'};
  color: ${props => props.active ? '#141204' : '#808285'};
  font-weight: ${props => props.active ? 700 : 400};
  background-color: transparent;
  white-space: nowrap;
  display: flex;
  align-items: center;
  &:hover {
    border-color: #FFCD00;
    background-color: transparent;
  }
  &:active {
    border-color: #FFCD00;
    color: #141204;
  }
  &:disabled {
    opacity: .2;
    background-color: transparent;
    color: #808285;
    &:hover {
      border-color: #E0E0E0;
      color: #808285;
    }
  }

  @media (max-width: 425px){
    font-size: 14px;
    line-height: 17px;
    padding: 13px 22px 10px;
  }
`
